export const optionsLegislation = [
  {
    value: "Наименование документа",
    key: "docName",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Документ",
    key: "file",
    type: "file",
    neededInModal: true,
  },
];

export const optionsPaidProc = [
  {
    value: "Наименование услуги",
    key: "name",
    type: "textarea",
    neededInModal: true,
  },
  {
    value: "Номер кода",
    key: "codeNumber",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Номер кода у агрегатора",
    key: "serviceEripCode",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Стоимость",
    key: "sum",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Тип услуги",
    key: "paidProcType",
    type: "selectWithSearch",
    neededInModal: true,
    options: [],
  },
];

export const optionsRequisitesChapter = [
  {
    value: "Название раздела",
    key: "apName",
    type: "text",
    neededInModal: true,
  },
];
export const optionsRequisitesLine = [
  {
    value: "Назначение платежа",
    key: "detName",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Номер кода",
    key: "codeNumber",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Номер кода у агрегатора",
    key: "serviceEripCode",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Стоимость",
    key: "sum",
    type: "text",
    neededInModal: true,
  },
];
export const optionsAdministrativeProcedures = [
  {
    value: "Наименование административной процедуры",
    key: "name",
    type: "textarea",
    neededInModal: true,
  },
  {
    value: "Документы и (или) сведения, представляемые заинтресованным лицом для осуществления АП",
    key: "docs",
    type: "textarea",
    neededInModal: true,
  },
  {
    value: "Вид и размер платы, взимаемой при осуществлении административной процедуры",
    key: "sum",
    type: "textarea",
    neededInModal: true,
  },
  {
    value: "Максимальный срок осуществления процедуры",
    key: "time1",
    type: "text",
    neededInModal: true,
  },
  {
    value: "Срок действия справки или другого документа, выдаваемого при осуществлении АП",
    key: "time2",
    type: "textarea",
    neededInModal: true,
  },
];

export function setPaidProcTypesOptions(lib) {
  for (let item in optionsPaidProc) {
    if (optionsPaidProc[item].key === "paidProcType") {
      if (optionsPaidProc[item].options.length === 0) {
        optionsPaidProc[item].options.push(...lib);
      }
    }
  }
}
